
export enum ActionTypes {
    EMAIL = "EMAIL_CUSTOMER",
    EMAIL_AGENT = "EMAIL_EMPLOYEE",
    DIRECT_MAILER = "DIRECT_MAILER",
    SENDGRID_SUBSCRIPTION = 'SENDGRID_SUBSCRIPTION',
    TWILIO_SMS = 'TWILIO_SMS'
}